{
  "CSAT": {
    "TITLE": "Évaluer votre conversation",
    "PLACEHOLDER": "Dites-nous en plus...",
    "RATINGS": {
      "POOR": "😞 Mauvais",
      "FAIR": "😑 Passable",
      "AVERAGE": "😐 Moyen",
      "GOOD": "😀 Bon",
      "EXCELLENT": "😍 Excellent"
    }
  }
}
